import styled from "styled-components";

const DivProfilePic = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    .company-img-div{
        min-height: 100px;
        width: 100%;
       
        margin: 15px 0;
        .company-img{
            width: 100%;
        }
        .company-placeholder{
            width: 100%;
            height: 100%;
            border: 1px solid var(--main-color);
            border-radius: 10px;
            p{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                font-size: 0.82rem;
                font-weight: 500;
                color: var(--input-font-color);
            }
        }
    }

   

    >img.business-pic{
        border-radius: 50%;
        width: 108px;
        height: 108px;
        margin: 10px 0;
    }

    >h3{
        margin: 10px 0;
        color: var(--default-color-font);
    }

    >label{
        position: absolute;
        width: 38px;
        height: 38px;
        background: #333;
        border-radius: 50%;
        border: 0;
        transition: 200ms;
        cursor: pointer;
        display:none;
        align-items:center;
        justify-content:center;
        left: 50%;
        transform: translate(-50%, 0);

        >input{
            display: none;
        }

        >svg{
            width: 26px;
            height: 26px;
            color: var(--grey-soft);  
            &:hover{
                color: #FFF;
            }
        }
    }

    &:hover{
        >label{
            display: flex;
        }
    }
    
`;

export default DivProfilePic;
